module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-senses-2c5f707d27c5105900b8d4fbc12a4314.svg";